/* sd-cart.js (2026-09-10, round 3, C1 build / C2 restyle). Dependency free driver for
 * snippets/sd-cart-drawer.liquid. Exposes window.SDCart = { add(items), open(), close(), refresh() }
 * so any buy button on the site can add a variant and get the same right hand drawer Lewis
 * pointed at on mattresscrafters.com.au, instead of a hard redirect to /cart.
 *
 * add(items) posts one call to /cart/add.js with { items: [...] }, matching Shopify's native
 * multi line add endpoint (used by sd-complete-the-bed to add a mattress plus extras in one
 * request). Everything else (quantity steppers, remove, subtotal, the cart count badge) reads
 * live from /cart.js, nothing is cached client side except the per-product compare-at lookup
 * below, which does not change during a session.
 *
 * C2 note: Shopify's /cart.js line item object does NOT carry the variant's compare_at_price
 * (confirmed live against this store, 2026-09-10: item.original_price/final_price only reflect
 * CART LEVEL discounts, not the product's retail compare-at). MC's "Save $X" line needs the real
 * retail saving, so refresh() additionally fetches /products/{handle}.js once per unique product
 * in the cart (cached in productCache for the life of the page) and reads compare_at_price off
 * the matching variant from there.
 */
(function () {
  if (window.SDCart) return;

  var ROOT_ID = 'sd-cart-drawer';
  var EN_DASH = String.fromCharCode(8211);
  var lastFocus = null;
  var busy = false;
  var productCache = {};

  function root() { return document.getElementById(ROOT_ID); }
  function q(sel) { var r = root(); return r ? r.querySelector(sel) : null; }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* Mirrors snippets/sd-short-title.liquid: drop the SEO subtitle Shopify's own
   * cart.js item.product_title still carries in full ("DreamOasis Mattress {en
   * dash} Simple Comfort, Every Night" -> "DreamOasis Mattress"). */
  function shortTitle(full) {
    var t = (full || '').toString();
    var enDashSep = ' ' + EN_DASH + ' ';
    if (t.indexOf(enDashSep) > -1) return t.split(enDashSep)[0].trim();
    if (t.indexOf(' - ') > -1) return t.split(' - ')[0].trim();
    return t.trim();
  }

  function fmtMoney(cents) {
    var v = (cents || 0) / 100;
    var wholeCents = Math.round(v * 100) % 100 === 0;
    return '$' + v.toLocaleString('en-AU', {
      minimumFractionDigits: wholeCents ? 0 : 2,
      maximumFractionDigits: 2,
    });
  }

  function updateCountBadges(count) {
    var nodes = document.querySelectorAll('#sdnav-count, [data-sd-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = count;
    var headCount = q('[data-sdcd-count]');
    if (headCount) headCount.textContent = count;
  }

  /* Returns a promise for { variantId: compare_at_price_in_cents|null } for one product
   * handle, fetched once and cached for the life of the page. */
  function getCompareMap(handle) {
    if (!handle) return Promise.resolve({});
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var map = {};
          if (p && p.variants) {
            for (var i = 0; i < p.variants.length; i++) map[p.variants[i].id] = p.variants[i].compare_at_price;
          }
          return map;
        })
        .catch(function () { return {}; });
    }
    return productCache[handle];
  }

  var MINUS_SVG = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var PLUS_SVG = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var TRASH_SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 13h9l1-13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var EMPTY_HTML = '<div class="sdcd-empty"><p>Your cart is empty</p><a href="/collections/all" class="sdcd-empty-link">Continue shopping</a></div>';

  function lineHtml(item, compareAt) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
    var hasCompare = compareAt != null && compareAt > item.final_price;
    var saveTotal = hasCompare ? (compareAt - item.final_price) * item.quantity : 0;
    return (
      '<div class="sdcd-line" data-key="' + esc(item.key) + '">' +
        (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
        '<div class="sdcd-line-mid">' +
          '<a class="sdcd-line-name" href="' + esc(item.url) + '">' + esc(shortTitle(item.product_title)) + '</a>' +
          (variant ? '<div class="sdcd-line-var">' + variant + '</div>' : '') +
          '<div class="sdcd-line-price"><strong>' + fmtMoney(item.final_price) + '</strong>' +
            (hasCompare ? '<span class="sdcd-line-was">' + fmtMoney(compareAt) + '</span>' : '') +
          '</div>' +
          (saveTotal > 0 ? '<div class="sdcd-line-save">Save ' + fmtMoney(saveTotal) + '</div>' : '') +
        '</div>' +
        '<div class="sdcd-line-right">' +
          '<div class="sdcd-step">' +
            '<button type="button" data-step="-1" aria-label="Decrease quantity">' + MINUS_SVG + '</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-step="1" aria-label="Increase quantity">' + PLUS_SVG + '</button>' +
          '</div>' +
          '<button type="button" class="sdcd-remove" data-remove aria-label="Remove ' + esc(shortTitle(item.product_title)) + '">' + TRASH_SVG + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function setTotals(cart, compareMap) {
    var subtotalEl = q('[data-sdcd-subtotal]');
    var totalEl = q('[data-sdcd-total]');
    var savingsRow = q('[data-sdcd-savings-row]');
    var savingsEl = q('[data-sdcd-savings]');
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    if (subtotalEl) subtotalEl.textContent = fmtMoney(sub);
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);
    var totalSave = 0;
    (cart.items || []).forEach(function (item) {
      var compareAt = compareMap[item.variant_id];
      if (compareAt != null && compareAt > item.final_price) totalSave += (compareAt - item.final_price) * item.quantity;
    });
    if (savingsRow) savingsRow.hidden = totalSave <= 0;
    if (savingsEl) savingsEl.textContent = fmtMoney(totalSave);
  }

  function render(cart) {
    var body = q('[data-sdcd-body]');
    if (!body) return Promise.resolve();
    updateCountBadges(cart.item_count);
    if (!cart.items || !cart.items.length) {
      body.innerHTML = EMPTY_HTML;
      setTotals(cart, {});
      return Promise.resolve();
    }
    var handles = [];
    cart.items.forEach(function (item) { if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle); });
    return Promise.all(handles.map(getCompareMap)).then(function (maps) {
      var compareMap = {};
      for (var i = 0; i < maps.length; i++) { for (var k in maps[i]) compareMap[k] = maps[i][k]; }
      body.innerHTML = cart.items.map(function (item) { return lineHtml(item, compareMap[item.variant_id]); }).join('');
      setTotals(cart, compareMap);
    });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return render(cart).then(function () { return cart; }); });
  }

  function open() {
    var r = root();
    if (!r) return;
    lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var panel = r.querySelector('.sdcd-panel');
    if (panel) panel.focus();
    document.addEventListener('keydown', onKeydown, true);
  }

  function close() {
    var r = root();
    if (!r) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e) {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var panel = r.querySelector('.sdcd-panel');
    var focusable = panel.querySelectorAll('a[href], button:not([disabled])');
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function add(items) {
    if (!items || !items.length) return Promise.resolve(null);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || 'add failed'); });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function (cart) { open(); return cart; });
  }

  function changeQty(key, quantity) {
    if (busy) return Promise.resolve(null);
    busy = true;
    var r = root();
    if (r) {
      var buttons = r.querySelectorAll('.sdcd-step button, .sdcd-remove');
      for (var i = 0; i < buttons.length; i++) buttons[i].disabled = true;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function (cart) { busy = false; return cart; });
  }

  function boot() {
    var r = root();
    if (!r) return;
    r.addEventListener('click', function (e) {
      if (e.target.closest('[data-sdcd-close]')) { close(); return; }
      var step = e.target.closest('[data-step]');
      if (step) {
        var line = step.closest('.sdcd-line');
        var qtyEl = line.querySelector('.sdcd-step span');
        var qty = parseInt(qtyEl.textContent, 10) || 1;
        changeQty(line.getAttribute('data-key'), qty + parseInt(step.getAttribute('data-step'), 10));
        return;
      }
      var remove = e.target.closest('[data-remove]');
      if (remove) {
        var removeLine = remove.closest('.sdcd-line');
        changeQty(removeLine.getAttribute('data-key'), 0);
      }
    });
    /* Populate current cart state on load without opening, so a returning
     * shopper who opens the drawer later sees what is actually in their cart. */
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.SDCart = { add: add, open: open, close: close, refresh: refresh };
})();
